import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useSwipeable } from 'react-swipeable'; // Import swipeable
import icons from "../../../icons.config";
import { useNavigate } from 'react-router-dom';
import GlobalButton from '../../GlobalButton';
import { useDispatch, useSelector } from 'react-redux';
import { addLikedItem, removeLikedItem } from '../../../store/likedItemsSlice';
import { setClickedItem } from '../../../store/itemsSlice';
import { FOUNDER_IMAGE_URL, IMAGE_BASE_URL } from '../../../api-urls';

const Collections = ({ data }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleItems, setVisibleItems] = useState(3); // Default for large screens
  const [autoPlay, setAutoPlay] = useState(true); // Auto-animate for smaller screens
  const [isFading, setIsFading] = useState(false); // Manage fading effect
  const navigate = useNavigate(); // Initialize useNavigate

  // Dispatch and likedItems state
  const dispatch = useDispatch();
  const likedItems = useSelector((state) => state.likedItems); // Get the list of liked items from the store

  // Handle resize for showing items and autoplay
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setVisibleItems(2); // Show 2 items on small and medium screens
        setAutoPlay(true); // Enable autoplay on smaller screens
      } else {
        setVisibleItems(3); // Show 3 items on large screens
        setAutoPlay(false); // Disable autoplay on larger screens
      }
    };
    handleResize(); // Set initial state based on window size
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Handle next/previous arrows
  const handleNext = () => {
    setIsFading(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % data.length);
      setIsFading(false);
    }, 500);
  };

  const handlePrev = () => {
    setIsFading(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex - 1 + data.length) % data.length);
      setIsFading(false);
    }, 500);
  };

  // Helper function to get visible dresses
  const getVisibleDresses = () => {
    const endIndex = currentIndex + visibleItems;
    let visibleData = data.slice(currentIndex, endIndex);
  
    if (endIndex > data.length) {
      visibleData = [...visibleData, ...data.slice(0, endIndex - data.length)];
    }
  
    console.log('Visible dresses:', visibleData);
  
    return [...new Set(visibleData)]; // Ensure unique items
  };
  

  // const getVisibleDresses = () => {
  //   if (!data || data.length === 0) return []; // Ensure data exists
  
  //   let visibleData = [];
  
  //   for (let i = 0; i < visibleItems; i++) {
  //     const index = (currentIndex + i) % data.length;
  //     visibleData.push(data[index]);
  //   }
  
  //   console.log("Visible dresses:", visibleData);
  //   return visibleData;
  // };
  

  // Handle dot click for navigation
  const numberOfDots = Math.ceil(data.length / visibleItems);
  const handleDotClick = (index) => {
    setIsFading(true);
    setTimeout(() => {
      setCurrentIndex(index * visibleItems);
      setIsFading(false);
    }, 500);
  };

  const handlers = useSwipeable({
    onSwipedLeft: handleNext,
    onSwipedRight: handlePrev,
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  // Handle click on a dress item
  const handleDressClick = (item) => {
    const selectedVariant = item.defaultVariant; // Access the default variant
    dispatch(setClickedItem(selectedVariant)); // Save the default variant details
    navigate(`/view/product/${item._id}`);
  };

  // Handle heart (like) click
  const handleHeartClick = (item) => {
    // const isLiked = likedItems.some((likedItem) => likedItem.id === item.id);
    // if (isLiked) {
    //   dispatch(removeLikedItem(item));
    // } else {
    //   dispatch(addLikedItem(item));
    // }
  };

  const goToShop = () => {
    navigate("/shop");
  };

  return (
    <div className="flex flex-col justify-center items-center w-full h-full bg-tertiary  pb-24 xl:pb-40 relative space-y-5 overflow-hidden">
      <h1 className='text-primary1 font-poppins text-3xl lg:py-4 mt-2 font-extralight '>OUR COLLECTION</h1>

      <div className="relative w-full max-w-7xl h-full" {...handlers}>
        <img src={icons.arrowLeft} alt="left arrow" className="absolute lg:left-7 xl:-left-1 top-[45%] transform -translate-y-1/2 text-primary1 text-lg font-semibold w-8 h-8 rounded-[50%] z-20 bg-secondary hidden lg:block" onClick={handlePrev} />

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-6 md:gap-10 lg:gap-6 px-11 md:px-11 xl:px-2">
          {getVisibleDresses().map((item, index) => {
            console.log('Item:', item);
            const defaultVariant = item.default_variant; // Access the default variant
            const imagePath = `${FOUNDER_IMAGE_URL}${defaultVariant?.images[0] || '/variant_images/default-image.jpg'}`;

            return (
              <div key={item._id || index} className="text-left flex justify-center relative z-10">
              <motion.div className={`transition-opacity duration-500 ${isFading ? 'opacity-0' : 'opacity-100'}`}>
                {/* Set a fixed size for the div */}
                <div className="w-full h-96 md:w-[98%] md:h-screen relative cursor-pointer py-16">
                  <motion.img
                    src={imagePath}
                    alt={item.product_name}
                    className="w-full h-full object-cover" // Image now follows the div's size
                    onClick={() => handleDressClick(item)}
                  />
                  
                  {/* <div className="absolute top-20 right-4 cursor-pointer" onClick={() => handleHeartClick(item)}>
                    <img
                      src={likedItems.some((likedItem) => likedItem.id === item.id) ? icons.filledHeart : icons.heart}
                      alt="Heart Icon"
                      className="w-5 h-5 md:w-7 md:h-7"
                    />
                  </div> */}
                  <h2 className="font-normal mt-2 text-lg font-outfit text-primary1">{item.product_name}</h2>
                <p className="text-sm mt-1 font-poppins text-hcolor">
                  {defaultVariant?.price ? `${defaultVariant.price} INR` : 'Price not available'}
                </p>
                </div>
            
                
              </motion.div>
            </div>
            
            );
          })}
        </div>

        <img src={icons.arrowRight} alt="right arrow" className="absolute top-[45%] lg:right-7 xl:-right-2 transform -translate-y-1/2 hidden text-primary1 rounded-[50%] bg-secondary lg:block w-8 h-8 z-10" onClick={handleNext} />
      </div>

      {/* Dots for carousel */}
      <div className="flex justify-center pt-8 z-50 lg:hidden relative top-7">
        {Array.from({ length: numberOfDots }).map((_, dotIndex) => (
          <button
            key={dotIndex}
            onClick={() => handleDotClick(dotIndex)}
            className={`w-2 h-2 md:h-3 md:w-3 mx-2 rounded-full ${dotIndex === Math.floor(currentIndex / visibleItems) ? 'bg-hcolor' : 'bg-white border border-hcolor'} shadow-lg`}
          />
        ))}
      </div>

      <div className='flex justify-center mt-16 pt-10 pb-1'>
        <button className='border-2 py-2 px-4 flex text-hcolor font-outfit font-medium hover:bg-hcolor hover:text-primary2 transition-all duration-500 ease-in-out'>
          <GlobalButton label="VIEW ALL" routeName="shop" onClick={goToShop} />
        </button>
      </div>
    </div>
  );
};


export default Collections;




// import React, { useState, useEffect } from 'react';
// import { motion } from 'framer-motion';
// import { useSwipeable } from 'react-swipeable';
// import images from '../../../images.config';
// import icons from "../../../icons.config";
// import { useNavigate } from 'react-router-dom';
// import GlobalButton from '../../GlobalButton';
// import { useDispatch, useSelector } from 'react-redux';
// import { addLikedItem, removeLikedItem } from '../../../store/likedItemsSlice'; 
// import { setClickedItem } from '../../../store/itemsSlice';

// const API_URL = "/api/product/getAllActiveProducts";

// const Collections = () => { 
//   const [products, setProducts] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [visibleItems, setVisibleItems] = useState(3);
//   const [autoPlay, setAutoPlay] = useState(true);
//   const [isFading, setIsFading] = useState(false);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const likedItems = useSelector((state) => state.likedItems);

//   useEffect(() => {
//     const fetchProducts = async () => {
//       try {
//         const response = await fetch(API_URL);
//         const data = await response.json();
//         setProducts(data); // Set fetched data to state
//       } catch (error) {
//         console.error("Error fetching products:", error);
//       }
//     };

//     fetchProducts();
//   }, []);

//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth < 1024) {
//         setVisibleItems(2);
//         setAutoPlay(true);
//       } else {
//         setVisibleItems(3);
//         setAutoPlay(false);
//       }
//     };

//     handleResize();
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const handleNext = () => {
//     setIsFading(true);
//     setTimeout(() => {
//       setCurrentIndex((prevIndex) => (prevIndex + 1) % products.length);
//       setIsFading(false);
//     }, 500);
//   };

//   const handlePrev = () => {
//     setIsFading(true);
//     setTimeout(() => {
//       setCurrentIndex((prevIndex) => (prevIndex - 1 + products.length) % products.length);
//       setIsFading(false);
//     }, 500);
//   };

//   const getVisibleProducts = () => {
//     const endIndex = currentIndex + visibleItems;
//     return products.slice(currentIndex, endIndex).concat(
//       products.slice(0, endIndex > products.length ? endIndex - products.length : 0)
//     );
//   };

//   const numberOfDots = Math.ceil(products.length / visibleItems);
//   const handleDotClick = (index) => {
//     setIsFading(true);
//     setTimeout(() => {
//       setCurrentIndex(index * visibleItems);
//       setIsFading(false);
//     }, 500);
//   };

//   const handlers = useSwipeable({
//     onSwipedLeft: handleNext,
//     onSwipedRight: handlePrev,
//     preventDefaultTouchmoveEvent: true,
//     trackMouse: true,
//   });

//   const handleProductClick = (item) => {
//     dispatch(setClickedItem(item));
//     navigate(`/view/product/${item.id}`);
//   };

//   const handleHeartClick = (item) => {
//     const isLiked = likedItems.some((likedItem) => likedItem.id === item.id);
//     isLiked ? dispatch(removeLikedItem(item)) : dispatch(addLikedItem(item));
//   };

//   const goToShop = () => {
//     navigate("/shop");
//   };

//   return (
//     <div className="flex flex-col justify-center items-center w-full h-full bg-tertiary custom-range:bg-primary1 pt-12 pb-24 xl:pb-40 relative space-y-5 overflow-hidden">
//       <h1 className='text-primary1 font-poppins text-3xl lg:py-4 mt-2 font-extralight mb-12'>OUR COLLECTION</h1>
//       <div className="relative w-full max-w-7xl h-full" {...handlers}>
//         <img src={icons.arrowLeft} alt="left arrow"
//           className="absolute lg:left-7 xl:-left-1 top-[45%] hidden lg:block w-8 h-8 z-20 bg-secondary rounded-full cursor-pointer"
//           onClick={handlePrev}
//         />

//         <div className="grid grid-cols-2 lg:grid-cols-3 gap-6 px-11 xl:px-2">
//           {getVisibleProducts().map((item) => (
//             <div key={item.id} className="text-left flex justify-center relative z-10">
//               <motion.div className={`transition-opacity duration-500 ${isFading ? 'opacity-0' : 'opacity-100'}`}>
//                 <motion.img
//                   src={item.thumbnail}
//                   alt={item.title}
//                   className="w-full object-cover mb-4 cursor-pointer"
//                   onClick={() => handleProductClick(item)}
//                 />
//                 <div className="absolute top-4 right-4 cursor-pointer" onClick={() => handleHeartClick(item)}>
//                   <img
//                     src={likedItems.some((likedItem) => likedItem.id === item.id) ? icons.filledHeart : icons.heart}
//                     alt="Heart Icon"
//                     className="w-5 h-5 md:w-7 md:h-7"
//                   />
//                 </div>
//                 <h2 className="font-normal mt-2 text-lg font-outfit text-primary1">{item.title}</h2>
//                 <p className="text-sm mt-1 font-poppins text-hcolor">{item.price}</p>
//               </motion.div>
//             </div>
//           ))}
//         </div>

//         <img src={icons.arrowRight} alt="right arrow"
//           className="absolute top-[45%] lg:right-7 xl:-right-2 hidden lg:block w-8 h-8 z-10 bg-secondary rounded-full cursor-pointer"
//           onClick={handleNext}
//         />
//       </div>

//       <div className="flex justify-center pt-8 lg:hidden relative top-7">
//         {Array.from({ length: numberOfDots }).map((_, dotIndex) => (
//           <button
//             key={dotIndex}
//             onClick={() => handleDotClick(dotIndex)}
//             className={`w-2 h-2 md:h-3 md:w-3 mx-2 rounded-full ${dotIndex === Math.floor(currentIndex / visibleItems) ? 'bg-hcolor' : 'bg-white border border-hcolor'} shadow-lg`}
//           />
//         ))}
//       </div>

//       <div className='flex justify-center mt-16 pt-10 pb-1'>
//         <button className='border-2 py-2 px-4 flex text-hcolor font-outfit font-medium hover:bg-hcolor hover:text-primary2 transition-all duration-500 ease-in-out'>
//           <GlobalButton label="VIEW ALL" routeName="shop" onClick={goToShop} />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Collections;

// import React, { useState, useEffect } from 'react';
// import { motion } from 'framer-motion';
// import { useSwipeable } from 'react-swipeable';
// import images from '../../../images.config';
// import icons from "../../../icons.config";
// import { useNavigate } from 'react-router-dom';
// import GlobalButton from '../../GlobalButton';
// import { useDispatch, useSelector } from 'react-redux';
// import { addLikedItem, removeLikedItem } from '../../../store/likedItemsSlice'; 
// import { setClickedItem } from '../../../store/itemsSlice';
// import { getAllActiveProductsApi } from './getAllActiveProductsApi';

// const Collections = () => { 
//   const [products, setProducts] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [visibleItems, setVisibleItems] = useState(3);
//   const [autoPlay, setAutoPlay] = useState(true);
//   const [isFading, setIsFading] = useState(false);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const likedItems = useSelector((state) => state.likedItems);

//   useEffect(() => {
//     const getProducts = async () => {
//       const response = await getAllActiveProductsApi();
//       console.log("Fetched products:", response.data); // Debugging
//       setProducts(response.data );
//     };
//     getProducts();
//   }, []);
//   // useEffect(() => {
//   //   const getProducts = async () => {
//   //     const response = await getAllActiveProductsApi();
//   //     const uniqueProducts = Array.from(new Map(response.data.map(item => [item._id, item])).values());
//   //     console.log("Unique products:", uniqueProducts);
//   //     setProducts(uniqueProducts);
//   //   };
//   //   getProducts();
//   // }, []);
  
  

//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth < 1024) {
//         setVisibleItems(2);
//         setAutoPlay(true);
//       } else {
//         setVisibleItems(3);
//         setAutoPlay(false);
//       }
//     };

//     handleResize();
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const handleNext = () => {
//     setIsFading(true);
//     setTimeout(() => {
//       setCurrentIndex((prevIndex) => (prevIndex + 1) % products.length);
//       setIsFading(false);
//     }, 500);
//   };

//   const handlePrev = () => {
//     setIsFading(true);
//     setTimeout(() => {
//       setCurrentIndex((prevIndex) => (prevIndex - 1 + products.length) % products.length);
//       setIsFading(false);
//     }, 500);
//   };

//   const getVisibleProducts = () => {
//     const endIndex = currentIndex + visibleItems;
//     return products.slice(currentIndex, endIndex).concat(
//       products.slice(0, endIndex > products.length ? endIndex - products.length : 0)
//     );
//   };

//   const numberOfDots = Math.ceil(products.length / visibleItems);
//   const handleDotClick = (index) => {
//     setIsFading(true);
//     setTimeout(() => {
//       setCurrentIndex(index * visibleItems);
//       setIsFading(false);
//     }, 500);
//   };

//   const handlers = useSwipeable({
//     onSwipedLeft: handleNext,
//     onSwipedRight: handlePrev,
//     preventDefaultTouchmoveEvent: true,
//     trackMouse: true,
//   });

//   const handleProductClick = (item) => {
//     dispatch(setClickedItem(item));
//     navigate(`/view/product/${item.id}`);
//   };

//   const handleHeartClick = (item) => {
//     const isLiked = likedItems.some((likedItem) => likedItem.id === item.id);
//     isLiked ? dispatch(removeLikedItem(item)) : dispatch(addLikedItem(item));
//   };

//   const goToShop = () => {
//     navigate("/shop");
//   };

//   return (
//     <div className="flex flex-col justify-center items-center w-full h-full bg-tertiary custom-range:bg-primary1 pt-12 pb-24 xl:pb-40 relative space-y-5 overflow-hidden">
//       <h1 className='text-primary1 font-poppins text-3xl lg:py-4 mt-2 font-extralight mb-12'>OUR COLLECTION</h1>
//       <div className="relative w-full max-w-7xl h-full" {...handlers}>
//         <img src={icons.arrowLeft} alt="left arrow"
//           className="absolute lg:left-7 xl:-left-1 top-[45%] hidden lg:block w-8 h-8 z-20 bg-secondary rounded-full cursor-pointer"
//           onClick={handlePrev}
//         />

// <div className="grid grid-cols-2 lg:grid-cols-3 gap-6 px-11 xl:px-2">
//   {getVisibleProducts().map((item,index) => {
//     const firstVariant = item.variants?.[0]; // Get the first variant safely
//     const productImage = item.product_images?.variants?.[0] || "/default-image.jpg"; // Fallback if no image exists

//     return (
//       <div key={`${item._id}-${index}`} className="text-left flex justify-center relative z-10">
//         <motion.div className={`transition-opacity duration-500 ${isFading ? 'opacity-0' : 'opacity-100'}`}>
//           <motion.img
//             src={productImage}
//             alt={item.product_name}
//             className="w-full object-cover mb-4 cursor-pointer"
//             onClick={() => handleProductClick(item)}
//           />
//           <div className="absolute top-4 right-4 cursor-pointer" onClick={() => handleHeartClick(item)}>
//             <img
//               src={likedItems.some((likedItem) => likedItem._id === item._id) ? icons.filledHeart : icons.heart}
//               alt="Heart Icon"
//               className="w-5 h-5 md:w-7 md:h-7"
//             />
//           </div>
//           <h2 className="font-normal mt-2 text-lg font-outfit text-primary1">{item.product_name}</h2>
//           <p className="text-sm mt-1 font-poppins text-hcolor">
//             {firstVariant
//               ? firstVariant.discount_price || firstVariant.price
//               : "Price Not Available"}
//           </p>
//         </motion.div>
//       </div>
//     );
//   })}
// </div>

//         <img src={icons.arrowRight} alt="right arrow"
//           className="absolute top-[45%] lg:right-7 xl:-right-2 hidden lg:block w-8 h-8 z-10 bg-secondary rounded-full cursor-pointer"
//           onClick={handleNext}
//         />
//       </div>

//       <div className="flex justify-center pt-8 lg:hidden relative top-7">
//         {Array.from({ length: numberOfDots }).map((_, dotIndex) => (
//           <button
//             key={dotIndex}
//             onClick={() => handleDotClick(dotIndex)}
//             className={`w-2 h-2 md:h-3 md:w-3 mx-2 rounded-full ${dotIndex === Math.floor(currentIndex / visibleItems) ? 'bg-hcolor' : 'bg-white border border-hcolor'} shadow-lg`}
//           />
//         ))}
//       </div>

//       <div className='flex justify-center mt-16 pt-10 pb-1'>
//         <button className='border-2 py-2 px-4 flex text-hcolor font-outfit font-medium hover:bg-hcolor hover:text-primary2 transition-all duration-500 ease-in-out'>
//           <GlobalButton label="VIEW ALL" routeName="shop" onClick={goToShop} />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Collections;
